import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaBrain } from 'react-icons/fa';
import { useAsyncApiJob } from '../../services';
import { AsyncApiJobResult, AsyncApiJobOutcome } from '../../services/use-asyncapijob';
import { t } from 'i18next';
import { toastSuccess, toastFailure, FormCol4 } from 'motion-components';
import { useParams } from 'react-router-dom';

export const ButtonCalcIsAppropriatePackaging = ({ refetch }: { refetch: () => void }) => {
  const triggerAsyncJobUrl = process.env.VITE_TRIGGER_ASYNC_JOB;
  const { id } = useParams<{ id: string }>();
  const { runJob, loading: loadingRbCheckOrderRequest } = useAsyncApiJob({
    url: triggerAsyncJobUrl ?? '',
    onJobFinished: async (status: AsyncApiJobOutcome, job: AsyncApiJobResult | null, errorMessage?: string) => {
      if (status === 'COMPLETED') {
        toastSuccess('Ο υπολογισμός με AI ολοκληρώθηκε επιτυχώς');
        await refetch?.();
      } else if (status === 'FAILED') {
        toastFailure('Ο υπολογισμός  με AI απέτυχε');
      } else if (status === 'CANCELLED') {
        toastFailure('Ο υπολογισμός  με AI ακυρώθηκε');
      } else if (status === 'EXPIRED') {
        toastFailure('Ο υπολογισμός  με AI έληξε');
      } else if (status === 'ERROR') {
        toastFailure(errorMessage ?? 'Αποτυχία εκκίνησης υπολογισμού με AI');
      }
    },
  });
  function handleCalculate(event: any): void {
    runJob({ jobType: 'rb-order-calc-isappropriatapackaging', collectionOrderId: id });
  }

  return (
    <Button
      name="rbOrderCalcIsAppropriatePackaging"
      size="sm"
      variant="outline-primary"
      onClick={handleCalculate}
      disabled={!triggerAsyncJobUrl}
      title={!triggerAsyncJobUrl ? t('Ρύθμιση VITE_TRIGGER_ASYNC_JOB απαιτείται') : undefined}
    >
      {loadingRbCheckOrderRequest ? (
        <span className="mb-1 me-2">
          <Spinner animation="border" size="sm" />
        </span>
      ) : (
        <FaBrain className="mb-1 me-2" />
      )}
      Υπολογισμός Καταλληλότητας συσκευασίας με AI
    </Button>
  );
};
